<template>
  <div class="testimonial">
    <h5 class="mb-3" v-html="question.the_question"></h5>
    <div v-if="response">
      <p>{{ testimonial_text }}</p>
    </div>
    <div class="whisper" v-else>No response yet</div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export default {
  props: ['question', 'recipient_id'],
  data() {
    return {
      editing: false,
    }
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses']),
    response() {
      return this.surveyResponses.find(
        (r) => r.question_id === this.question.id && r.recipient_id === Number(this.recipient_id),
      )
    },
    testimonial_text() {
      return this.response?.text_answer
    },
  },
  methods: {},
}
</script>
<style lang="sass" scoped>
h5
  line-height: 140%
  margin-bottom: 16px
.question:hover
  border: 1px solid white !important
</style>
